export default "__VITE_ASSET__D0z5xaFI__"